import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }
const _hoisted_2 = { class: "popup-wrapper" }
const _hoisted_3 = { style: {"margin-top":"12px"} }
const _hoisted_4 = { class: "report-popup-actions" }
const _hoisted_5 = { class: "report-popup-action" }
const _hoisted_6 = { class: "report-popup-action" }
const _hoisted_7 = {
  key: 0,
  style: {"color":"red","font-size":"12px","margin-top":"5px","text-align":"center"}
}
const _hoisted_8 = { style: {"display":"flex","flex-direction":"column","height":"100%"} }
const _hoisted_9 = { style: {"flex":"1","border-top":"1px solid #ddd"} }
const _hoisted_10 = ["src"]
const _hoisted_11 = { style: {"display":"flex","justify-content":"center","align-items":"center","gap":"16px","padding":"12px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dsReports,
      ref: "dataGridRef",
      "allow-column-reordering": false,
      "allow-column-resizing": true,
      "column-auto-width": false,
      "show-borders": true,
      "key-expr": "ID",
      onRowClick: _ctx.onReportRowClick,
      "search-expr": ['nume', 'query', 'modul']
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 240,
          placeholder: "Cauta ..."
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "nume",
          caption: "Nume"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "modul",
          caption: "Modul",
          visible: false,
          "allow-search": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "queryType",
          caption: "Query Type",
          "calculate-display-value": _ctx.calcQueryType,
          "allow-search": false
        }, null, 8, ["calculate-display-value"]),
        _createVNode(_component_DxColumn, {
          "data-field": "query",
          caption: "Query",
          "allow-search": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "layout",
          visible: false,
          "allow-search": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "options",
          visible: false,
          "allow-search": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "parameters",
          visible: false,
          "allow-search": false
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "layoutXml",
          visible: false,
          "allow-search": false
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, { name: "searchPanel" }),
            _createVNode(_component_DxItem, {
              location: "before",
              widget: "dxDropDownButton",
              options: _ctx.modelButtonOptions
            }, null, 8, ["options"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source", "onRowClick"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isPopupVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isPopupVisible) = $event)),
      width: 500,
      height: 'auto',
      "show-close-button": true,
      "hide-on-outside-click": true
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.selectedReportName), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_component_DxForm, {
            key: _ctx.formKey,
            "form-data": _ctx.dynamicFormData,
            items: _ctx.formItems,
            "col-count": 1
          }, null, 8, ["form-data", "items"])),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_DxButton, {
                  text: "Execută Raport",
                  type: "default",
                  width: "100%",
                  disabled: !_ctx.selectedDesignID,
                  onClick: _ctx.executeReport
                }, null, 8, ["disabled", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_DxButton, {
                  text: "Copiază link",
                  icon: "link",
                  type: "normal",
                  width: "100%",
                  style: {"flex":"1"},
                  onClick: _ctx.copyReportShareUrl
                }, null, 8, ["onClick"])
              ])
            ]),
            (!_ctx.selectedDesignID)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, " * Acest raport nu are un layout definit. "))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isPdfPreviewVisible,
      width: 1700,
      height: 900,
      "hide-on-outside-click": true
    }, {
      title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Previzualizare Raport ", -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.pdfBlobUrl)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 0,
                  src: _ctx.pdfBlobUrl,
                  style: {"width":"100%","height":"100%","border":"0"}
                }, null, 8, _hoisted_10))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_DxButton, {
              text: "Descarcă PDF",
              icon: "download",
              type: "success",
              onClick: _ctx.downloadPreviewPdf
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              icon: "close",
              onClick: _ctx.closePdfPreview
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}